import React, { Component } from 'react';
import axios from 'axios'
import {PasswordReset} from './PasswordReset/PasswordReset'
import {baseUrl} from './assets/Animations'



class Login extends Component {
    constructor() {
        super();

        this.state = {
            teachers: [],
            email: '',
            password: '',
            resetOpen: false,
            abbreviation: '',
            schoolAbb: ''
        }
    }

    componentDidMount = () => {
        this.setTheSchool()
    }

    setTheSchool = () => {
        let url = window.location.href
        let trimmed = url.substring(8)
        let name = trimmed.split('.')[0]
        if(name === 'mountainside') {
            this.setState({
                abbreviation: 'MMA',
                schoolAbb: 'MMA'
            })
        } else if (name === 'lakeside') {
            this.setState({
                abbreviation: 'LSMA',
                schoolAbb: 'LSMA'
            })
        } else if (name === 'treeside') {
            this.setState({
                abbreviation: 'TSMA',
                schoolAbb: 'TMA'
            })
        } else if (name === 'morningside') {
            this.setState({
                abbreviation: 'MMA',
                schoolAbb: 'MMA'
            })    
        }
    }

    adminSubmit = async () => {
        axios.post(`${baseUrl}/login`, {
            Email: this.state.email,
            Password: this.state.password
        })
        .then(response => {
            if(response.data.user.School === 'admin') {
                this.props.onLoggedIn(response.data)
                //GETTING CONVOS
                // axios.get(`${baseUrl}/chats`)
                // .then(response => {
                //     this.props.logConvos(response.data)
                //     //checkForUnreadMessages(response.data)
                // })
                // .catch(err => {
                //     console.log(err)
                // })
            } else {
                alert('Access not granted')
            }
        })
        .catch(e => {
            console.log(e)
            alert('Incorrect Username or Password. Please try again...')
        })
    }

    submit = async () => {
        let preparedEmail = this.state.email
        preparedEmail = preparedEmail.toLowerCase().trim()
        axios.post(`${baseUrl}/login`, {
            Email: preparedEmail,
            Password: this.state.password
        })
        .then(response => {
            this.props.onLoggedIn(response.data)
        })
        .catch(e => {
            console.log('no such user ' + e)
            console.log(e)
            alert('Incorrect Username or Password. Please try again...')
        })
    }
    setEmail = (e) => {
        this.setState({email: e})
    }
    setPassword = (e) => {
        this.setState({password: e})
    }
    toggleReset = () => {
        if(this.state.resetOpen === false) {
            this.setState({resetOpen: true})
        } else {
            this.setState({resetOpen: false})
        }
    }
    render() {
        if (this.props.accessPoint === 'admin') {
            return(
                <div className="login-page" style={{backgroundImage: `url(./login-background.jpg)`}}>
                    <div className="login-header">
                        {this.state.abbreviation} Admin Portal
                    </div>
                    <div className="login-box">
                        <div className="login-box-title">Login</div>
                        <input className="username-input login-input" placeholder="Email" onChange={e => this.setEmail(e.target.value)} ></input>
                        <input className="password-input login-input" type="password" placeholder="Password" onChange={e => this.setPassword(e.target.value)} ></input>
                        <div className="login-btn" onClick={() => this.adminSubmit()}>Login</div>
                    </div>
                </div>
            )
        } else {
            return(
                <div className="login-page" style={{backgroundImage: `url(./${this.state.schoolAbb}.jpg)`}}>
                    <PasswordReset resetOpen={this.state.resetOpen} toggleReset={this.toggleReset} />
                    <div className="login-header">
                        {this.state.abbreviation} Teacher Portal
                    </div>
                    <div className="login-box">
                        <div className="login-box-title">Login</div>
                        <input className="username-input login-input" placeholder="Email" onChange={e => this.setEmail(e.target.value)} ></input>
                        <input className="password-input login-input" type="password" placeholder="Password" onChange={e => this.setPassword(e.target.value)} ></input>
                        <div className="login-btn" onClick={() => this.submit()}>Login</div>
                        <div className="forgot-password" onClick={() => this.toggleReset()}>Forgot my password</div>
                    </div>
                </div>
            )
        }
    }
}

export default Login